import { render } from "./Information.vue?vue&type=template&id=a57ce202&ts=true&lang=pug"
import script from "./Information.vue?vue&type=script&setup=true&lang=ts"
export * from "./Information.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__